import type { Route } from 'vue-router'
import axios from 'axios'
import { collectAttributionParams, hasAdAttributionParams } from '@/composables/useAttribution'
import { getClientGroupName } from '@/config/brands/clientGroup'
import { STORAGE_MEMBER_ID } from '@/constants'
import { $getDeviceId, $getToken } from '@/helpers'
import i18n, { LOCALE_MAP } from '@/i18n'
import { useUserStore } from '@/stores'
import { clearEmpty } from '@/utils/clearEmpty'

function getTrackingBaseURL() {
  if (import.meta.env.MODE === 'development')
    return 'https://tracking-api-test.rocnovel.com'
  return `${location.origin}/${import.meta.env.VITE_TRACK_PREFIX}`
}

export async function reportH5Ad(route?: Route) {
  if (!hasAdAttributionParams(route))
    return

  try {
    const params = await collectAttributionParams(route, {
      waitForCookies: false,
      syncStore: false,
    })

    const userStore = useUserStore()
    const memberId = userStore.memberId || localStorage.getItem(STORAGE_MEMBER_ID) || ''
    const body: PostDeviceAdH5ReportBody = clearEmpty({
      ...params,
      memberId: memberId || undefined,
    })

    if (!Object.keys(body).length)
      return

    await axios.post<PostDeviceAdH5ReportResponse>('/device/ad/h5Report', body, {
      baseURL: getTrackingBaseURL(),
      headers: {
        Platform: 3,
        versionCode: '110',
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        clientGroupName: getClientGroupName(),
        contentType: '4',
        language: LOCALE_MAP[i18n.locale as keyof typeof LOCALE_MAP] || LOCALE_MAP.en,
        ...(userStore.isLogin() && $getToken() ? { Authorization: $getToken() } : {}),
        ...($getDeviceId() ? { equipmentId: $getDeviceId() } : {}),
      },
    })
  }
  catch (error) {
    console.warn('h5Report failed', error)
  }
}
